import { render, staticRenderFns } from "./ShopListItem.vue?vue&type=template&id=86dfa2c4&"
import script from "./ShopListItem.vue?vue&type=script&lang=js&"
export * from "./ShopListItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports